import i18n from 'i18next'
import Backend from 'i18next-locize-backend'
import Editor from 'locize-editor'
import LastUsed from 'locize-lastused'
import { initReactI18next } from 'react-i18next'
import moment from 'moment'

// WE MUST IMPORT EVERY MOMENT LOCALE MATCHING THE AVAILABLE LANGUAGES
// TODO: use dynamic imports
import 'moment/dist/locale/es'
import 'moment/dist/locale/en-gb'
import 'moment/dist/locale/pt'

// OPTIONAL IF YOU LIKE TO SEE ALL (LOGIN TO TRANSLATION MANAGEMENT EDITOR)
// 1) signup at https://locize.com/register and login
// 2) create a new project
// 3) copy/paste your projectId, apiKey below
// 4) add de as additional language
// 5a) import en from: http://api.locize.io/ce0cf818-32e5-44a5-b7f0-4ea9e840d962/latest/en/translation
// 5b) import de from: http://api.locize.io/ce0cf818-32e5-44a5-b7f0-4ea9e840d962/latest/de/translation
const locizeOptions = {
  projectId: '0e330a78-600b-40d4-9e3d-c6893b8942fa',
  apiKey: '78309ec6-1a57-4a6a-91a2-19ac5aed2d7a', // YOU should not expose your apps API key to production!!!
  crossDomain: true, //need to CORS HTTP errow with locize
  referenceLng: 'es',
}

const getAdminLanguage = () => {
  let language = ''
  const defaultLanguage = 'es'
  const browserLanguage = window.navigator.language.split('-')[0]
  const cacheLanguage = localStorage.getItem('i18nextLng')
  if (isAvaliableLanguage(browserLanguage) && !cacheLanguage) language = browserLanguage
  if (!isAvaliableLanguage(browserLanguage) && !cacheLanguage) language = defaultLanguage
  if (cacheLanguage) language = cacheLanguage
  return language
}
const adminLanguages = ['es', 'en', 'pt']
const isAvaliableLanguage = (language) => adminLanguages.includes(language)

const initializeI18n = () => {
  const language = getAdminLanguage()

  i18n
    // i18next-locize-backend
    // loads translations from your project, saves new keys to it (saveMissing: true)
    // https://github.com/locize/i18next-locize-backend
    .use(Backend)
    // locize-lastused
    // sets a timestamp of last access on every translation segment on locize
    // -> safely remove the ones not being touched for weeks/months
    // https://github.com/locize/locize-lastused
    .use(LastUsed)
    // locize-editor
    // InContext Editor of locize ?locize=true to show it
    // https://github.com/locize/locize-editor
    .use(Editor)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
      // lng: 'es', //delete if by geolocalization
      lng: language,
      fallbackLng: language,
      whitelist: adminLanguages,
      debug: process.env.NODE_ENV !== 'production',
      saveMissing: true,
      load: 'all',

      backend: locizeOptions,
      locizeLastUsed: locizeOptions,

      editor: {
        ...locizeOptions,
        onEditorSaved: async (lng, ns) => {
          // reload that namespace in given language
          await i18n.reloadResources(lng, ns)
          // trigger an event on i18n which triggers a rerender
          // based on bindI18n below in react options
          i18n.emit('editorSaved')
        },
      },
      react: {
        bindI18n: 'languageChanged editorSaved',
      },
    })
  i18n.on('languageChanged', function (language) {
    const previousLanguage = localStorage.getItem('i18nextLng')
    localStorage.setItem('i18nextLng', language)
    moment.locale(language)
    if (previousLanguage && previousLanguage !== language) window.location.reload()
  })
  i18n.on('initialized', function (options) {
    localStorage.setItem('i18nextLng', options.lng)
  })
  return i18n
}

export default initializeI18n
